import { isStaffRole } from '@repo/types'

/** Rola (@Roles('ASSISTANT') na /assistant/*, TIPER/LAWYER nie) + prepínač „AI asistent" v Môj tím → Nastavenia (zhodné s assertAssistantEnabled na API). */
export function canUseAssistant(user: { role: string; assistantEnabled?: boolean } | null | undefined): boolean {
  if (!user || !isStaffRole(user.role)) return false
  return user.role === 'SUPER_ADMIN' || user.assistantEnabled !== false
}

/** localStorage kľúč rozpracovaného chatu — maže ho aj logout (lib/auth), chat patrí používateľovi, nie prehliadaču. */
export const ASSISTANT_CHAT_ID_KEY = 'assistant.chatId'
